import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core'

@Component({
  selector: 'lin-toolbar-search-results',
  template: `
    <div *ng linPerfectScrollbar class="container mat-elevation-z2">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      .container {
        background-color: var(--primary-background-color);
        width: 25em;
        margin-top: 2px;
        padding: 0;
        border-radius: 4px;
        max-height: 60vh;
      }
    `,
  ],
  exportAs: 'linToolbarSearchResults',
  standalone: false,
})
export class ToolbarSearchResultsComponent implements OnInit {
  @Output() opened = new EventEmitter()

  @ViewChild(TemplateRef, { static: true }) template: TemplateRef<any>

  constructor() {}

  ngOnInit() {}
}
